
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutHFr3ugLvnt6IHybt_45a_45DzO8HSFAomizyTZBLf0NC3F4Meta } from "/data/code/equirize/prod/pages/about.vue?macro=true";
import { default as indexwGRfMfS1kue1CfPFGh76mw6XvJmw2tPqpqEGK3CBq2IMeta } from "/data/code/equirize/prod/pages/index.vue?macro=true";
import { default as refer92qm94858EjkW678uZBG_Dts6J_45MFgDQToV8Z_45Yyg7QMeta } from "/data/code/equirize/prod/pages/refer.vue?macro=true";
import { default as sitemapKMr7_450Y544lSEeMT_45r_45Ziu1e6wex6oWsQBpJ5u1_CVIMeta } from "/data/code/equirize/prod/pages/sitemap.vue?macro=true";
import { default as contact_45us9I87iU5Jxb6pT18iG4DpXxQ2iWJJIntgMABoYdthgAsMeta } from "/data/code/equirize/prod/pages/contact-us.vue?macro=true";
import { default as privacy_45policyHLb41ICTH674wLcQSEc4DZNARTn0y7dnUi2_BBRum4kMeta } from "/data/code/equirize/prod/pages/privacy-policy.vue?macro=true";
import { default as exploreN0Kw0KOrDgJetMbwf3_4HF27_DjgSAD0Kek1kVtmZtgMeta } from "/data/code/equirize/prod/pages/products/explore.vue?macro=true";
import { default as _91slug_93sHUPo0PHgPYxKTgrjb_UBLseqKHgJ3oeE_pOHcgiW5wMeta } from "/data/code/equirize/prod/pages/products/ipo/[slug].vue?macro=true";
import { default as index2_jwYAX_45HIsoke1FxTX5g9QRovIsoVeHVuNGSozyVkYMeta } from "/data/code/equirize/prod/pages/products/bonds/index.vue?macro=true";
import { default as indexqtnFsWCJZiwU_45anrHiVFdPRNfNzMkVwqd0dnk_45iL9_MMeta } from "/data/code/equirize/prod/pages/resources/news/index.vue?macro=true";
import { default as terms_45and_45conditionsp_45_W5jQHrNqaNnw6JNWyPtC3GFbqUlEGMiVTYNeWYOgMeta } from "/data/code/equirize/prod/pages/terms-and-conditions.vue?macro=true";
import { default as _91slug_93ysylnNzxSa_zsNVDXeM62aElbCMMWBRgFBDaqV7JRGUMeta } from "/data/code/equirize/prod/pages/products/bonds/[slug].vue?macro=true";
import { default as indexmymrJ2hZkJSCAJaOZ_EqRSzqSj5wRK4P3bb7bnPGhbAMeta } from "/data/code/equirize/prod/pages/resources/blogs/index.vue?macro=true";
import { default as fixedDepositsCone8_452gKsCiO3Vt_UayL_45hxVb7x39TethmgJ5pjOksMeta } from "/data/code/equirize/prod/pages/products/fixedDeposits.vue?macro=true";
import { default as _91policy_93uO9IzglGQlwk4xP48lJRtmfobGmY6HrBnigDwyz5UlAMeta } from "/data/code/equirize/prod/pages/legal-compliance/[policy].vue?macro=true";
import { default as _91titleUrl_930BWoTsqUBHhGC45FOwxSHKlb7mG3fHOWB2ND5VB0Vp8Meta } from "/data/code/equirize/prod/pages/resources/news/[titleUrl].vue?macro=true";
import { default as _91titleUrl_93NAbYornRkbDh1c5hZcNC4dVHua8dOcDFAr_lIvjN60gMeta } from "/data/code/equirize/prod/pages/resources/blogs/[titleUrl].vue?macro=true";
import { default as component_45stubAHq99vvavpxFO9rys9bedZePGoqYMik6YLFKdTTM5hEMeta } from "/data/code/equirize/prod/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubAHq99vvavpxFO9rys9bedZePGoqYMik6YLFKdTTM5hE } from "/data/code/equirize/prod/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/data/code/equirize/prod/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/data/code/equirize/prod/pages/index.vue")
  },
  {
    name: "refer",
    path: "/refer",
    component: () => import("/data/code/equirize/prod/pages/refer.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/data/code/equirize/prod/pages/sitemap.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/data/code/equirize/prod/pages/contact-us.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/data/code/equirize/prod/pages/privacy-policy.vue")
  },
  {
    name: "products-explore",
    path: "/products/explore",
    component: () => import("/data/code/equirize/prod/pages/products/explore.vue")
  },
  {
    name: "products-ipo-slug",
    path: "/products/ipo/:slug()",
    component: () => import("/data/code/equirize/prod/pages/products/ipo/[slug].vue")
  },
  {
    name: "products-bonds",
    path: "/products/bonds",
    component: () => import("/data/code/equirize/prod/pages/products/bonds/index.vue")
  },
  {
    name: "resources-news",
    path: "/resources/news",
    component: () => import("/data/code/equirize/prod/pages/resources/news/index.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/data/code/equirize/prod/pages/terms-and-conditions.vue")
  },
  {
    name: "products-bonds-slug",
    path: "/products/bonds/:slug()",
    component: () => import("/data/code/equirize/prod/pages/products/bonds/[slug].vue")
  },
  {
    name: "resources-blogs",
    path: "/resources/blogs",
    component: () => import("/data/code/equirize/prod/pages/resources/blogs/index.vue")
  },
  {
    name: "products-fixedDeposits",
    path: "/products/fixedDeposits",
    component: () => import("/data/code/equirize/prod/pages/products/fixedDeposits.vue")
  },
  {
    name: "legal-compliance-policy",
    path: "/legal-compliance/:policy()",
    component: () => import("/data/code/equirize/prod/pages/legal-compliance/[policy].vue")
  },
  {
    name: "resources-news-titleUrl",
    path: "/resources/news/:titleUrl()",
    component: () => import("/data/code/equirize/prod/pages/resources/news/[titleUrl].vue")
  },
  {
    name: "resources-blogs-titleUrl",
    path: "/resources/blogs/:titleUrl()",
    component: () => import("/data/code/equirize/prod/pages/resources/blogs/[titleUrl].vue")
  },
  {
    name: component_45stubAHq99vvavpxFO9rys9bedZePGoqYMik6YLFKdTTM5hEMeta?.name,
    path: "/products",
    component: component_45stubAHq99vvavpxFO9rys9bedZePGoqYMik6YLFKdTTM5hE
  },
  {
    name: component_45stubAHq99vvavpxFO9rys9bedZePGoqYMik6YLFKdTTM5hEMeta?.name,
    path: "/resources",
    component: component_45stubAHq99vvavpxFO9rys9bedZePGoqYMik6YLFKdTTM5hE
  },
  {
    name: component_45stubAHq99vvavpxFO9rys9bedZePGoqYMik6YLFKdTTM5hEMeta?.name,
    path: "/legal-compliance",
    component: component_45stubAHq99vvavpxFO9rys9bedZePGoqYMik6YLFKdTTM5hE
  },
  {
    name: component_45stubAHq99vvavpxFO9rys9bedZePGoqYMik6YLFKdTTM5hEMeta?.name,
    path: "/contactUs",
    component: component_45stubAHq99vvavpxFO9rys9bedZePGoqYMik6YLFKdTTM5hE
  }
]